import { ModalDialog, ModalMessage, ModalMessageColorsEnum } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

type TimeKeepingResetModalProps = {
  isOpen: boolean;
  scope: 'all' | 'support';
  onClose: () => void;
  onConfirm: () => void;
};

export function TimeKeepingResetModal({
  isOpen,
  scope,
  onClose,
  onConfirm,
}: TimeKeepingResetModalProps) {
  const { t } = useTranslation();
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      onAction={onConfirm}
      heading={t('Reiniciar tiempos')}
      actionLabel={t('Reiniciar')}
      linkLabel={t('Cancelar')}
      color={ModalMessageColorsEnum.ERROR}
    >
      <ModalMessage
        title={t(
          scope === 'support'
            ? '¿Estás seguro de que quieres eliminar todos los registros guardados para este soporte?'
            : '¿Estás seguro de que quieres eliminar todos los registros guardados?'
        )}
      />
    </ModalDialog>
  );
}
